// extracted by mini-css-extract-plugin
export default {"version-info":"Footer_version-info__iGOaI"};